/**
 * @fileoverview
 * Local/Session Storage Keys Constants
 * 
 * @version 1.0.0
 * @author KATALYST TEAM
 */

export const STORAGE_KEYS = {
  // Authentication
  ACCESS_TOKEN: 'los_audit_token',
  REFRESH_TOKEN: 'los_audit_refresh_token',
  CSRF_TOKEN: 'los_audit_csrf_token',
  USER_DATA: 'los_audit_user',
  PERMISSIONS: 'los_audit_permissions',
  /** Cached GET /config rows (after login). */
  SYSTEM_CONFIG: 'los_audit_system_config',
  REMEMBER_ME: 'los_audit_remember_me',
  
  // User Preferences
  THEME: 'los_audit_theme',
  LANGUAGE: 'los_audit_language',
  SIDEBAR_COLLAPSED: 'los_audit_sidebar_collapsed',
  /** Globally selected branch (header); set on login / session load. */
  SELECTED_BRANCH: 'los_audit_selected_branch',
  /** Globally selected audit type (header); Regular | Surprise. */
  SELECTED_AUDIT_TYPE: 'los_audit_selected_audit_type',
  
  // Cache
  LAST_ROUTE: 'los_audit_last_route',
  FORM_DATA: 'los_audit_form_data',
} as const;

